import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { RefinanceContext, RefinanceDebt } from "@/features/refinance/types";
import { sumCommittedDebts } from "@/features/refinance/utils/debt-status";
import {
	type RefinanceAllocation,
	resolveRefinanceAllocation,
} from "@/features/refinance/utils/refinance-allocation";

/**
 * The allocation for the debts currently in the form. Only committed debts
 * count, so a half-filled card cannot skew the figures the customer is shown.
 */
export const useRefinanceAllocation = (
	context: RefinanceContext
): RefinanceAllocation => {
	const { control } = useFormContext();
	const debts = useWatch({ control, name: "debts" }) as
		RefinanceDebt[] | undefined;

	const { offer, appliedRefinance } = context;

	return useMemo(
		() =>
			resolveRefinanceAllocation({
				offer,
				appliedRefinance,
				collected: sumCommittedDebts(debts ?? []),
			}),
		[offer, appliedRefinance, debts]
	);
};
